/* =========================================================================
   Versiani Swim — Central de Atendimento (vanilla JS)
   Lê o JSON serializado pelo Liquid e renderiza home / categoria / artigo /
   busca / contato via navegação hash-based. Sem dependências.
   ========================================================================= */
(function () {
  'use strict';

  const VersianiFAQ = {
    instances: {},

    init(sectionId) {
      const root = document.getElementById('vs-faq-root-' + sectionId);
      if (!root) return;
      const dataScript = document.querySelector('[data-vs-data-' + sectionId + ']');
      if (!dataScript) return;

      let data;
      try {
        data = JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('[VersianiFAQ] dados inválidos:', e);
        return;
      }

      // Agrupa artigos por categoria em FAQ_DATA estruturado
      const categoriesMap = {};
      data.categories.forEach((c, idx) => {
        categoriesMap[c.id] = {
          id: c.id,
          name: c.name,
          description: c.description,
          order: c.order || idx + 1,
          articles: []
        };
      });
      data.articles.forEach((a) => {
        if (categoriesMap[a.categoryId]) {
          categoriesMap[a.categoryId].articles.push(a);
        } else {
          console.warn('[VersianiFAQ] artigo sem categoria pai:', a.id, a.categoryId);
        }
      });
      const FAQ_DATA = Object.values(categoriesMap).sort((a, b) => a.order - b.order);

      const instance = {
        root,
        data,
        config: data.config,
        FAQ_DATA,
        main: root.querySelector('[data-vs-main]'),
        state: { helpful: null },
      };
      this.instances[sectionId] = instance;

      this._render(instance);

      window.addEventListener('hashchange', () => this._render(instance));
    },

    // ---------- Helpers ----------
    _parseHash() {
      const h = (location.hash || '').replace(/^#\/?/, '');
      if (!h) return { view: 'home' };
      const [view, a, b] = h.split('/');
      if (view === 'c' && a) return { view: 'category', categoryId: a };
      if (view === 'a' && a && b) return { view: 'article', categoryId: a, articleId: b };
      if (view === 's') return { view: 'search', q: decodeURIComponent(a || '') };
      if (view === 'contato') return { view: 'contact' };
      return { view: 'home' };
    },
    _toHash(r) {
      if (r.view === 'category') return '#/c/' + r.categoryId;
      if (r.view === 'article') return '#/a/' + r.categoryId + '/' + r.articleId;
      if (r.view === 'search') return '#/s/' + encodeURIComponent(r.q || '');
      if (r.view === 'contact') return '#/contato';
      return '#/';
    },
    _navigate(r) {
      location.hash = this._toHash(r);
      window.scrollTo({ top: 0, behavior: 'instant' });
    },
    _findCategory(instance, id) {
      return instance.FAQ_DATA.find((c) => c.id === id);
    },
    _findArticle(instance, catId, artId) {
      const cat = this._findCategory(instance, catId);
      if (!cat) return null;
      const art = cat.articles.find((a) => a.id === artId);
      return art ? Object.assign({}, art, { categoryName: cat.name, categoryId: cat.id }) : null;
    },
    _allArticles(instance) {
      return instance.FAQ_DATA.flatMap((c) =>
        c.articles.map((a) => Object.assign({}, a, { categoryName: c.name, categoryId: c.id }))
      );
    },
    _searchArticles(instance, q) {
      if (!q || !q.trim()) return [];
      const needle = q.toLowerCase();
      return this._allArticles(instance).filter(
        (a) =>
          (a.title || '').toLowerCase().includes(needle) ||
          (a.description || '').toLowerCase().includes(needle) ||
          (a.content || '').toLowerCase().includes(needle)
      );
    },
    _esc(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    // permite <em> no título (usado em settings)
    _escAllowEm(str) {
      const s = this._esc(str);
      return s.replace(/&lt;em&gt;/g, '<em>').replace(/&lt;\/em&gt;/g, '</em>');
    },
    _pad(n) {
      return String(n).padStart(2, '0');
    },

    // ---------- Icons ----------
    _icons: {
      search:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>',
      arrow:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M4 12h16M14 6l6 6-6 6"/></svg>',
      arrowLeft:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M20 12H4M10 18l-6-6 6-6"/></svg>',
      whatsapp:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.7-1.2A9 9 0 1 0 12 3z"/><path d="M8.5 8.5c0 3.5 3.5 7 7 7l1.5-1.5-2-1-1 1c-1.5 0-3-1.5-3-3l1-1-1-2-1.5 1.5z"/></svg>',
      instagram:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><rect x="3" y="3" width="18" height="18" rx="4.5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.9" fill="currentColor" stroke="none"/></svg>',
    },
    _svg(name, cls, size) {
      const s = size || 16;
      const classAttr = cls ? ' class="' + cls + '"' : '';
      return this._icons[name].replace(
        '<svg ',
        '<svg width="' + s + '" height="' + s + '"' + classAttr + ' '
      );
    },

    // ---------- Markdown-lite renderer ----------
    _mdInline(text) {
  let out = this._esc(text);

  out = out
    .replace(/&lt;(strong|b)&gt;/gi, '<strong>')
    .replace(/&lt;\/(strong|b)&gt;/gi, '</strong>')
    .replace(/&lt;(em|i)&gt;/gi, '<em>')
    .replace(/&lt;\/(em|i)&gt;/gi, '</em>')
    .replace(/&lt;br\s*\/?&gt;/gi, '<br>')
    .replace(
      /&lt;a\s+href=&quot;([^"]+)&quot;&gt;(.*?)&lt;\/a&gt;/gi,
      '<a href="$1">$2</a>'
    );

  out = out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  out = out.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  out = out.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');

  return out;
},
    _renderMarkdown(content) {
  if (!content) return '';

  let text = String(content).trim();

  // Normaliza HTML do rich text do Shopify para um formato que o parser entende
  text = text
    .replace(/\r\n/g, '\n')
    .replace(/&nbsp;/gi, ' ')
    .replace(/<br\s*\/?>/gi, '\n')

    // headings HTML -> markdown
    .replace(/<h2[^>]*>([\s\S]*?)<\/h2>/gi, '\n\n## $1\n\n')
    .replace(/<h3[^>]*>([\s\S]*?)<\/h3>/gi, '\n\n### $1\n\n')
    .replace(/<h4[^>]*>([\s\S]*?)<\/h4>/gi, '\n\n#### $1\n\n')

    // blockquote
    .replace(/<blockquote[^>]*>([\s\S]*?)<\/blockquote>/gi, '\n\n> $1\n\n')

    // listas ordenadas
    .replace(/<ol[^>]*>([\s\S]*?)<\/ol>/gi, function (_, inner) {
      let index = 0;
      return '\n' + inner.replace(/<li[^>]*>([\s\S]*?)<\/li>/gi, function (_, li) {
        index += 1;
        return index + '. ' + li + '\n';
      }) + '\n';
    })

    // listas não ordenadas
    .replace(/<ul[^>]*>([\s\S]*?)<\/ul>/gi, function (_, inner) {
      return '\n' + inner.replace(/<li[^>]*>([\s\S]*?)<\/li>/gi, function (_, li) {
        return '- ' + li + '\n';
      }) + '\n';
    })

    // parágrafos e containers
    .replace(/<\/p>\s*<p[^>]*>/gi, '\n\n')
    .replace(/<p[^>]*>/gi, '')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<div[^>]*>/gi, '\n')
    .replace(/<\/div>/gi, '\n')

    // hr html -> markdown hr
    .replace(/<hr[^>]*\/?>/gi, '\n\n---\n\n');

  const lines = text.split('\n');
  const out = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];
    const trimmed = line.trim();

    if (trimmed === '') {
      i++;
      continue;
    }

    if (/^---+$/.test(trimmed)) {
      out.push('<hr>');
      i++;
      continue;
    }

    if (trimmed.startsWith('#### ')) {
      out.push('<h4>' + this._mdInline(trimmed.slice(5)) + '</h4>');
      i++;
      continue;
    }

    if (trimmed.startsWith('### ')) {
      out.push('<h3>' + this._mdInline(trimmed.slice(4)) + '</h3>');
      i++;
      continue;
    }

    if (trimmed.startsWith('## ')) {
      out.push('<h2>' + this._mdInline(trimmed.slice(3)) + '</h2>');
      i++;
      continue;
    }

    // tabela markdown
    if (
      trimmed.startsWith('|') &&
      i + 1 < lines.length &&
      /^\s*\|?[\s\-|:]+\|?\s*$/.test(lines[i + 1])
    ) {
      const head = trimmed.replace(/^\||\|$/g, '').split('|').map((s) => s.trim());
      i += 2;
      const rows = [];

      while (i < lines.length && lines[i].trim().startsWith('|')) {
        rows.push(
          lines[i].trim().replace(/^\||\|$/g, '').split('|').map((s) => s.trim())
        );
        i++;
      }

      let tbl = '<table><thead><tr>';
      head.forEach((h) => {
        tbl += '<th>' + this._mdInline(h) + '</th>';
      });
      tbl += '</tr></thead><tbody>';

      rows.forEach((r) => {
        tbl += '<tr>';
        r.forEach((c) => {
          tbl += '<td>' + this._mdInline(c) + '</td>';
        });
        tbl += '</tr>';
      });

      tbl += '</tbody></table>';
      out.push(tbl);
      continue;
    }

    if (trimmed.startsWith('> ')) {
      const buf = [];
      while (i < lines.length && lines[i].trim().startsWith('> ')) {
        buf.push(lines[i].trim().slice(2));
        i++;
      }
      out.push('<blockquote>' + this._mdInline(buf.join(' ')) + '</blockquote>');
      continue;
    }

    if (/^[-*] /.test(trimmed)) {
      const items = [];
      while (i < lines.length && /^[-*] /.test(lines[i].trim())) {
        items.push(lines[i].trim().slice(2));
        i++;
      }
      out.push('<ul>' + items.map((it) => '<li>' + this._mdInline(it) + '</li>').join('') + '</ul>');
      continue;
    }

    if (/^\d+\. /.test(trimmed)) {
      const items = [];
      while (i < lines.length && /^\d+\. /.test(lines[i].trim())) {
        items.push(lines[i].trim().replace(/^\d+\.\s*/, ''));
        i++;
      }
      out.push('<ol>' + items.map((it) => '<li>' + this._mdInline(it) + '</li>').join('') + '</ol>');
      continue;
    }

    const buf = [trimmed];
    i++;
    while (
      i < lines.length &&
      lines[i].trim() !== '' &&
      !/^(#{2,4} |---+$|\| |[-*] |\d+\. |> )/.test(lines[i].trim())
    ) {
      buf.push(lines[i].trim());
      i++;
    }

    out.push('<p>' + this._mdInline(buf.join(' ')) + '</p>');
  }

  return out.join('\n');
},

    // ---------- Render ----------
    _render(instance) {
      const route = this._parseHash();
      instance.state.helpful = null;
      const main = instance.main;
      let html = '';

      if (route.view === 'home') html = this._homeHTML(instance);
      else if (route.view === 'category') html = this._categoryHTML(instance, route.categoryId);
      else if (route.view === 'article') html = this._articleHTML(instance, route.categoryId, route.articleId);
      else if (route.view === 'search') html = this._searchHTML(instance, route.q);
      else if (route.view === 'contact') html = this._contactHTML(instance);
      else html = this._homeHTML(instance);

      main.innerHTML = html;
      main.setAttribute('data-screen-label', this._screenLabel(route));
      this._wirePage(instance, route);

      // Atualiza nav ativo
      instance.root.querySelectorAll('.vs-header-nav a').forEach((a) => a.classList.remove('is-active'));
      if (route.view === 'home') {
        const el = instance.root.querySelector('.vs-header-nav a[data-nav*="home"]');
        if (el) el.classList.add('is-active');
      } else if (route.view === 'contact') {
        const el = instance.root.querySelector('.vs-header-nav a[data-nav*="contact"]');
        if (el) el.classList.add('is-active');
      }
    },

    _screenLabel(r) {
      if (r.view === 'home') return '01 Home';
      if (r.view === 'category') return '02 Categoria';
      if (r.view === 'article') return '03 Artigo';
      if (r.view === 'search') return '04 Busca';
      if (r.view === 'contact') return '05 Contato';
      return '';
    },

    _wirePage(instance, route) {
      // Navegação genérica
      instance.main.querySelectorAll('[data-nav]').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          try {
            const r = JSON.parse(el.getAttribute('data-nav'));
            this._navigate(r);
          } catch (err) {}
        });
      });

      // Busca (home e página de busca)
      const form = instance.main.querySelector('[data-vs-search-form]');
      if (form) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const input = form.querySelector('[data-vs-search-input]');
          const q = input ? input.value.trim() : '';
          if (q) this._navigate({ view: 'search', q });
        });
      }

      // Botões "útil"
      instance.main.querySelectorAll('[data-vs-helpful]').forEach((el) => {
        el.addEventListener('click', () => {
          const val = el.getAttribute('data-vs-helpful');
          instance.state.helpful = val;
          const row = el.parentElement;
          row.querySelectorAll('[data-vs-helpful]').forEach((b) => {
            b.classList.remove('is-yes', 'is-no');
          });
          el.classList.add(val === 'yes' ? 'is-yes' : 'is-no');
          const msg = instance.main.querySelector('[data-vs-helpful-msg]');
          if (msg) {
            if (val === 'yes') {
              msg.innerHTML =
                '<p style="margin-top:24px;font-family:var(--vs-display);font-style:italic;font-size:17px;color:var(--vs-ink)">Que bom. Obrigada pelo retorno.</p>';
            } else {
              msg.innerHTML =
                '<p style="margin-top:24px;font-family:var(--vs-display);font-style:italic;font-size:17px;color:var(--vs-ink)">Sem problema. <a href="#/contato" data-nav=\'{"view":"contact"}\' style="border-bottom:1px solid currentColor;cursor:pointer">Fale com a nossa consultora</a> e ela resolve pessoalmente.</p>';
              msg.querySelectorAll('[data-nav]').forEach((a) => {
                a.addEventListener('click', (e) => {
                  e.preventDefault();
                  this._navigate(JSON.parse(a.getAttribute('data-nav')));
                });
              });
            }
          }
        });
      });
    },

    // ---------- Views ----------
    _homeHTML(instance) {
      const cfg = instance.config;
      const allArticles = this._allArticles(instance);
      const cats = instance.FAQ_DATA;

      const popularHTML = (cfg.popularLabels || [])
        .map((p) => {
          const art = allArticles.find((a) => a.id === p.articleId);
          if (!art) return '';
          return (
            '<button type="button" data-nav=\'{"view":"article","categoryId":"' +
            this._esc(art.categoryId) + '","articleId":"' + this._esc(art.id) + '"}\'>' +
            this._esc(p.label || art.title) + '</button>'
          );
        })
        .filter(Boolean)
        .join('<span class="vs-sep">·</span>');

      const quick = (cfg.popularLabels || [])
        .slice(0, 6)
        .map((p) => {
          const art = allArticles.find((a) => a.id === p.articleId);
          if (!art) return '';
          return (
            '<button class="vs-quick-card" data-nav=\'{"view":"article","categoryId":"' +
            this._esc(art.categoryId) + '","articleId":"' + this._esc(art.id) + '"}\'>' +
              '<span class="vs-quick-card-label">' + this._esc(p.label) + '</span>' +
              '<span class="vs-quick-card-title">' + this._esc(art.title) + '</span>' +
            '</button>'
          );
        })
        .filter(Boolean)
        .join('');

      const catCards = cats
        .map((c, i) => {
          return (
            '<button class="vs-cat-card" data-nav=\'{"view":"category","categoryId":"' +
            this._esc(c.id) + '"}\'>' +
              '<div>' +
                '<div class="vs-cat-num">' + this._pad(i + 1) + ' · ' + c.articles.length + ' artigos</div>' +
                '<h3 class="vs-cat-name">' + this._esc(c.name) + '</h3>' +
                '<p class="vs-cat-desc">' + this._esc(c.description) + '</p>' +
              '</div>' +
              '<div class="vs-cat-foot">' +
                '<span>Explorar</span>' +
                this._svg('arrow', 'vs-cat-arrow', 18) +
              '</div>' +
            '</button>'
          );
        })
        .join('');

      return (
        '<div class="vs-fade-in">' +
          '<section class="vs-hero">' +
            '<div class="vs-hero-watermark" aria-hidden>VS</div>' +
            '<div class="vs-hero-inner">' +
              '<div class="vs-hero-eyebrow">' + this._esc(cfg.heroEyebrow) + '</div>' +
              '<h1 class="vs-hero-title">' + this._escAllowEm(cfg.heroTitle) + '</h1>' +
              '<p class="vs-hero-sub">' + this._esc(cfg.heroSub) + '</p>' +
              '<form class="vs-search" data-vs-search-form>' +
                '<div class="vs-search-box">' +
                  this._svg('search', 'vs-search-icon', 18) +
                  '<input class="vs-search-input" data-vs-search-input placeholder="' +
                    this._esc(cfg.searchPlaceholder) + '">' +
                  '<button type="submit" class="vs-search-btn">Buscar</button>' +
                '</div>' +
                (popularHTML
                  ? '<div class="vs-hero-suggests"><span>Populares</span>' + popularHTML + '</div>'
                  : '') +
              '</form>' +
            '</div>' +
          '</section>' +

          '<section class="vs-section">' +
            '<div class="vs-section-head">' +
              '<h2 class="vs-section-title">' + this._escAllowEm(cfg.sectionTitle) + '</h2>' +
              '<span class="vs-section-meta">' + cats.length + ' Coleções · ' +
                allArticles.length + ' artigos</span>' +
            '</div>' +
            '<div class="vs-cat-grid">' + catCards + '</div>' +
          '</section>' +

          (quick
            ? '<section class="vs-quick">' +
                '<div class="vs-quick-inner">' +
                  '<div class="vs-quick-head">' +
                    '<span class="vs-quick-eyebrow">' + this._esc(cfg.quickEyebrow) + '</span>' +
                    '<h3 class="vs-quick-title">' + this._esc(cfg.quickTitle) + '</h3>' +
                  '</div>' +
                  '<div class="vs-quick-grid">' + quick + '</div>' +
                '</div>' +
              '</section>'
            : '') +

          '<section class="vs-concierge">' +
            '<div class="vs-concierge-watermark" aria-hidden>VS</div>' +
            '<div class="vs-concierge-inner">' +
              '<div class="vs-concierge-eyebrow">' + this._esc(cfg.conciergeEyebrow) + '</div>' +
              '<h3 class="vs-concierge-title">' + this._escAllowEm(cfg.conciergeTitle) + '</h3>' +
              '<p class="vs-concierge-sub">' + this._esc(cfg.conciergeSub) + '</p>' +
              '<button class="vs-btn-ghost" data-nav=\'{"view":"contact"}\'>' +
                'Fale conosco ' + this._svg('arrow', '', 14) +
              '</button>' +
            '</div>' +
          '</section>' +
        '</div>'
      );
    },

    _categoryHTML(instance, categoryId) {
      const cat = this._findCategory(instance, categoryId);
      if (!cat) {
        return '<div class="vs-cat-page"><div class="vs-crumb"><a href="#/" data-nav=\'{"view":"home"}\'>Central</a><span class="vs-crumb-sep">/</span><span class="vs-crumb-current">Não encontrada</span></div><p>Categoria não encontrada.</p></div>';
      }
      const idx = instance.FAQ_DATA.findIndex((c) => c.id === categoryId) + 1;
      const rows = cat.articles
        .map(
          (a, i) =>
            '<button class="vs-article-row" data-nav=\'{"view":"article","categoryId":"' +
            this._esc(cat.id) + '","articleId":"' + this._esc(a.id) + '"}\'>' +
              '<div class="vs-article-row-inner">' +
                '<div class="vs-article-row-main">' +
                  '<div class="vs-article-row-num">' + this._pad(i + 1) + '</div>' +
                  '<h3 class="vs-article-row-title">' + this._esc(a.title) + '</h3>' +
                  '<p class="vs-article-row-desc">' + this._esc(a.description) + '</p>' +
                '</div>' +
                '<span class="vs-article-row-arrow">Ler ' + this._svg('arrow', '', 14) + '</span>' +
              '</div>' +
            '</button>'
        )
        .join('');

      return (
        '<div class="vs-cat-page vs-fade-in">' +
          '<div class="vs-crumb">' +
            '<a href="#/" data-nav=\'{"view":"home"}\'>Central</a>' +
            '<span class="vs-crumb-sep">/</span>' +
            '<span class="vs-crumb-current">' + this._esc(cat.name) + '</span>' +
          '</div>' +
          '<header class="vs-cat-page-head">' +
            '<div class="vs-cat-page-num">Coleção ' + this._pad(idx) + ' · ' + cat.articles.length + ' artigos</div>' +
            '<h1 class="vs-cat-page-title">' + this._esc(cat.name) + '</h1>' +
            '<p class="vs-cat-page-sub">' + this._esc(cat.description) + '</p>' +
          '</header>' +
          '<div class="vs-article-list">' + rows + '</div>' +
          '<div class="vs-article-nav" style="margin-top:56px">' +
            '<a class="vs-back" href="#/" data-nav=\'{"view":"home"}\'>' +
              this._svg('arrowLeft', '', 14) + ' Todas as coleções' +
            '</a>' +
          '</div>' +
        '</div>'
      );
    },

    _articleHTML(instance, categoryId, articleId) {
      const art = this._findArticle(instance, categoryId, articleId);
      if (!art) {
        return '<div class="vs-article"><p>Artigo não encontrado.</p></div>';
      }
      // remove primeiro ## se duplicar título
      let content = art.content || '';
      const lines = content.split('\n');
      let skipped = false;
      content = lines
        .filter((l) => {
          if (!skipped && /^##\s/.test(l.trim())) { skipped = true; return false; }
          return true;
        })
        .join('\n');

      return (
        '<article class="vs-article vs-fade-in">' +
          '<div class="vs-crumb">' +
            '<a href="#/" data-nav=\'{"view":"home"}\'>Central</a>' +
            '<span class="vs-crumb-sep">/</span>' +
            '<a href="#/c/' + this._esc(categoryId) + '" data-nav=\'{"view":"category","categoryId":"' +
              this._esc(categoryId) + '"}\'>' + this._esc(art.categoryName) + '</a>' +
            '<span class="vs-crumb-sep">/</span>' +
            '<span class="vs-crumb-current" style="max-width:220px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' +
              this._esc(art.title) + '</span>' +
          '</div>' +
          '<header class="vs-article-head">' +
            '<div class="vs-article-kicker">' + this._esc(art.categoryName) + '</div>' +
            '<h1 class="vs-article-title">' + this._esc(art.title) + '</h1>' +
            '<p class="vs-article-lede">' + this._esc(art.description) + '</p>' +
          '</header>' +
          '<div class="vs-prose">' + this._renderMarkdown(content) + '</div>' +
          '<div class="vs-article-foot" style="padding:0">' +
            '<div class="vs-helpful-label">Este artigo foi útil?</div>' +
            '<div class="vs-helpful-row">' +
              '<button class="vs-helpful-btn" data-vs-helpful="yes">Sim, resolveu</button>' +
              '<button class="vs-helpful-btn" data-vs-helpful="no">Ainda preciso de ajuda</button>' +
            '</div>' +
            '<div data-vs-helpful-msg></div>' +
          '</div>' +
          '<div class="vs-article-nav">' +
            '<a class="vs-back" href="#/c/' + this._esc(categoryId) + '" data-nav=\'{"view":"category","categoryId":"' +
              this._esc(categoryId) + '"}\'>' + this._svg('arrowLeft', '', 14) + ' Voltar para ' +
              this._esc(art.categoryName) + '</a>' +
            '<a class="vs-back" href="#/contato" data-nav=\'{"view":"contact"}\'>Fale conosco ' +
              this._svg('arrow', '', 14) + '</a>' +
          '</div>' +
        '</article>'
      );
    },

    _searchHTML(instance, q) {
      q = q || '';
      const results = this._searchArticles(instance, q);
      const rows = results
        .map(
          (a) =>
            '<button class="vs-article-row" data-nav=\'{"view":"article","categoryId":"' +
            this._esc(a.categoryId) + '","articleId":"' + this._esc(a.id) + '"}\'>' +
              '<div class="vs-article-row-inner">' +
                '<div class="vs-article-row-main">' +
                  '<div class="vs-article-row-num" style="color:var(--vs-gold)">' +
                    this._esc(a.categoryName) + '</div>' +
                  '<h3 class="vs-article-row-title">' + this._esc(a.title) + '</h3>' +
                  '<p class="vs-article-row-desc">' + this._esc(a.description) + '</p>' +
                '</div>' +
                '<span class="vs-article-row-arrow">Ler ' + this._svg('arrow', '', 14) + '</span>' +
              '</div>' +
            '</button>'
        )
        .join('');

      return (
        '<div class="vs-search-page vs-fade-in">' +
          '<div class="vs-crumb">' +
            '<a href="#/" data-nav=\'{"view":"home"}\'>Central</a>' +
            '<span class="vs-crumb-sep">/</span>' +
            '<span class="vs-crumb-current">Busca</span>' +
          '</div>' +
          '<header class="vs-search-page-head">' +
            '<div class="vs-search-page-kicker">Resultados</div>' +
            '<h1 class="vs-search-page-title">Busca por <em>"' + this._esc(q) + '"</em></h1>' +
            '<div class="vs-search-page-meta">' + results.length + ' ' +
              (results.length === 1 ? 'artigo' : 'artigos') + ' encontrados</div>' +
          '</header>' +
          '<form class="vs-search" style="margin:0 0 48px" data-vs-search-form>' +
            '<div class="vs-search-box">' +
              this._svg('search', 'vs-search-icon', 18) +
              '<input class="vs-search-input" data-vs-search-input value="' + this._esc(q) + '">' +
              '<button type="submit" class="vs-search-btn">Refinar</button>' +
            '</div>' +
          '</form>' +
          (results.length === 0
            ? '<div class="vs-search-empty">' +
                '<div class="vs-search-empty-title">Nada por aqui.</div>' +
                '<p>Tente termos mais gerais, ou <a href="#/contato" data-nav=\'{"view":"contact"}\' ' +
                  'style="border-bottom:1px solid currentColor;cursor:pointer;color:var(--vs-gold)">fale com a gente</a>.</p>' +
              '</div>'
            : '<div class="vs-article-list" style="border-top:1px solid var(--vs-line)">' + rows + '</div>') +
        '</div>'
      );
    },

    _contactHTML(instance) {
      const cfg = instance.config;
      const wa = cfg.whatsappUrl || '#';
      const ig = cfg.instagramUrl || '#';

      return (
        '<div class="vs-contact vs-fade-in">' +
          '<div class="vs-crumb" style="justify-content:center">' +
            '<a href="#/" data-nav=\'{"view":"home"}\'>Central</a>' +
            '<span class="vs-crumb-sep">/</span>' +
            '<span class="vs-crumb-current">Fale conosco</span>' +
          '</div>' +
          '<div class="vs-contact-eyebrow">' + this._esc(cfg.contactEyebrow) + '</div>' +
          '<h1 class="vs-contact-title">' + this._escAllowEm(cfg.contactTitle) + '</h1>' +
          '<p class="vs-contact-sub">' + this._esc(cfg.contactSub) + '</p>' +
          '<div class="vs-contact-cards">' +
            '<a class="vs-contact-card" href="' + this._esc(wa) + '" target="_blank" rel="noopener">' +
              '<span class="vs-contact-card-label">WhatsApp</span>' +
              '<h3 class="vs-contact-card-title">Conversa direta</h3>' +
              '<p class="vs-contact-card-desc">O canal mais rápido. Atendimento humano de segunda a sexta.</p>' +
              '<div class="vs-contact-card-foot">' + this._svg('whatsapp', '', 16) + ' Abrir conversa</div>' +
            '</a>' +
            '<a class="vs-contact-card" href="' + this._esc(ig) + '" target="_blank" rel="noopener">' +
              '<span class="vs-contact-card-label">Instagram</span>' +
              '<h3 class="vs-contact-card-title">@versianiswim</h3>' +
              '<p class="vs-contact-card-desc">Dúvidas, inspirações e novidades — responda nossos stories ou mande uma DM.</p>' +
              '<div class="vs-contact-card-foot">' + this._svg('instagram', '', 16) + ' Abrir Instagram</div>' +
            '</a>' +
          '</div>' +
          '<div class="vs-contact-hours">' +
            '<strong>Horário de atendimento</strong> &nbsp;·&nbsp; ' + this._esc(cfg.contactHours) +
          '</div>' +
        '</div>'
      );
    },
  };

  window.VersianiFAQ = VersianiFAQ;
  document.dispatchEvent(new CustomEvent('vs-faq-ready'));
})();
